
import {Component, Prop, Vue} from "vue-property-decorator";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import IconBtn from "@/components/molecules/IconBtn.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import ServiceImplementationInfo from "@/components/organisms/ServiceImplementationInfo.vue";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import {AssetsServiceProfileView, ServiceProfileView} from "@/components/organisms/ServiceProfileSource";

@Component({
  components: {
    HdsIdField,
    ServiceImplementationInfo,
    SimpleDialog,
    IconBtn,
    TextFieldLike
  },
})
export default class ServiceProfileInfo extends Vue {
  private serviceImplementationDialog = false;

  @Prop({
    type: Object,
    required: true,
  })
  private serviceProfileView!: ServiceProfileView | AssetsServiceProfileView;

  @Prop({
    type: Boolean,
    default: false
  })
  private loading!: boolean;

  get showSubtitle() {
    return !!this.$slots['subtitle']?.length;
  }

  get serviceProfile() {
    return this.serviceProfileView ?? {};
  }

  get serviceImplementation() {
    if('serviceImplementation' in this.serviceProfileView) {
      return this.serviceProfileView.serviceImplementation;
    } else {
      return {};
    }
  }

  get commonServiceComponentModel() {
    return this.serviceProfileView?.commonServiceComponentModel ?? {};
  }

  get localServiceComponentModel() {
    if('localServiceComponentModel' in this.serviceProfileView) {
      return this.serviceProfileView.localServiceComponentModel;
    } else {
      return {};
    }
  }
}
